export default {
    // récuperer toutes les guichets dans la base de données 
    get_all_planning(){
        return axios.get('/planning', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_planning_by_guichet(id){
        return axios.get('/planning/guichet/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_planning_by_user(id){
        return axios.get('/planning/user/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_planning_by_entite(id){
        return axios.get('/horaires/entite/'+id, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_solde_planning(){
        
        return axios.get('/planning/getsoldecaisse', {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les guichets dans la base de données 
    post_planning(taxe){
        return axios.post('/planning', taxe, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    post_horaire(horaire){
        return axios.post('/horaires', horaire, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    put_horaire(horaire){
        return axios.put('/horaires', horaire, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_planning(id,guichet){
        return axios.put('/planning/'+id,taxes, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_planning(id){
        return axios.get('/planning/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_planning(id){
        return axios.delete('/planning/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}